import React, { useRef } from 'react';

import { useDispatch } from 'store/configureStore';

import { setCaptchaResponse } from 'actions';
import { useTranslations } from 'utils';

import type { CaptchaRef } from '../thirdParty/Captcha/Captcha';
import { Captcha } from '../thirdParty/Captcha/Captcha';
import { FacebookSignIn } from './components/FacebookSignIn/FacebookSignIn';
import { GoogleSignIn } from './components/GoogleSignIn/GoogleSignIn';

export function SocialSignIn({
  onSuccess,
  onError,
  isLogin,
}: {
  onSuccess?: () => void;
  onError: (err?: unknown) => void;
  isLogin: boolean;
}) {
  const i18n = useTranslations();
  const dispatch = useDispatch();
  const captchaRef = useRef<CaptchaRef>(null);

  const onClickSignIn = (handleProviderSignIn: () => void) => {
    if (captchaRef?.current && captchaRef?.current.execute) {
      try {
        const result = captchaRef.current?.execute({ async: true });
        result?.then(
          () => handleProviderSignIn(),
          () => {},
        );
      } catch (_e) {}
    } else {
      handleProviderSignIn();
    }
  };

  const handleSignInWithCaptcha = async (token: string) => {
    if (token) {
      dispatch(setCaptchaResponse(token));
    } else {
      onError();
    }
  };

  return (
    <>
      <GoogleSignIn
        onClick={onClickSignIn}
        onSuccess={onSuccess}
        onError={onError}
        isLogin={isLogin}
      />

      <FacebookSignIn
        onClick={onClickSignIn}
        onSuccess={onSuccess}
        onError={onError}
        isLogin={isLogin}
      />

      <Captcha ref={captchaRef} onVerify={handleSignInWithCaptcha} />

      <div className="mb-4 flex flex-row items-center justify-center gap-2 pt-1 uppercase text-gray-700">
        <div className="w-full border-b border-gray-300 text-center leading-[0.1em]">
          &nbsp;
        </div>
        <span>{i18n.t('userLogin.social.or')}</span>
        <div className="w-full border-b border-gray-300 text-center leading-[0.1em]">
          &nbsp;
        </div>
      </div>
    </>
  );
}
